// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "4f8d2329",
    "hash": "4f8d2329",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "4f8d2329",
    "semverString": null,
    "version": "5.0.1"
};
/* tslint:enable */
